import {
  Box,
  TextField,
  Card,
  CardContent,
  Typography,
  Button,
  CardHeader,
  Divider,
  Grid,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Container,
} from '@mui/material';

import { useNavigate, useParams } from 'react-router-dom';
import { List, ListItem, CircularProgress } from '@mui/material';

import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useEffect, useState, useRef } from 'react';
import AWS from 'aws-sdk';
import axios from 'axios';
import { toast } from 'react-toastify';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Description } from '@mui/icons-material';

// AWS S3 Configuration
AWS.config.update({
  accessKeyId: 'AKIAWX5OXDFHSE3ZUKMI',
  secretAccessKey: '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',
  region: 'ap-south-1'
});

const EditMatrimonial = () => {
  const { id } = useParams();
  const [img, setImg] = useState('');
  const [users, setUsers] = useState([]);
  const [initialValuesLoaded, setInitialValuesLoaded] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(false); // For loading state
  const [showDropdown, setShowDropdown] = useState(false);
  const inputRef = useRef(null);
  const [imageErr, setImageErr] = useState(false);
  const [image, setImage] = useState(null);


  const navigate = useNavigate();

  const s3 = new AWS.S3();

  async function handleImageFile(e) {
    setImageErr(false);
    const file = e.target.files[0];
    const folderPath = 'community1/';
    if (file) {
      setImage(file.name);
      const params = {
        Bucket: 'chaturvedi-v2',
        Key: `${folderPath}${Date.now()}_${file.name}`,
        // Key: `${Date.now()}_${file.name}`,
        Body: file,
        ACL: 'public-read', // Ensure this is set according to your permissions
        ContentType: file.type // Set the content type
      };

      try {
        console.log('Uploading to S3...', params);
        const { Location } = await s3.upload(params).promise();
        setImg(Location);
        console.log('Upload successful:', Location);
      } catch (error) {
        console.error('Upload failed:', error);
        toast.error(`Upload failed: ${error.message}`, {
          position: 'bottom-right'
        });
      }
    } else {
      setImageErr(true);
    }
  }

  // Handle clicks outside the dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {

      // Check if the clicked element is outside both the dropdown and the input field
      if (
        inputRef.current && !inputRef.current.contains(event.target)
      ) {
        console.log('ddddddd')
        setShowDropdown(false); // Hide the dropdown
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    fetchMatrimonialData();

  }, [id]);

  const fetchMatrimonialData = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/matrimonial/getMatrimonial/${id}`);
      const { name, DOB, qualification, aboutMe, description, user, image, status } = response.data;
      console.log(response.data, "response datatat");
      const userid = response.data.user._id;

      const formateDOB = DOB ? new Date(DOB).toISOString().split('T')[0] : ' ';

      formik.setValues({
        name,
        DOB: formateDOB,
        qualification,
        description,
        status: status.toString(),
        aboutMe,
        user: userid,
        image,
      });
      setSelectedUser(`${user.name}/${user.area}/${user.familyId}`)

      setImg(image);
    } catch (error) {
      console.error('Error fetching matrimonial data:', error);
    } finally {
      setInitialValuesLoaded(true);
    }
  };

  const handleupdate = async (e) => {
    const keyword = e.target.value;
    console.log(e.key, 'eddddddddddddddddd')
    setSelectedUser(keyword); // Update the local state for the dropdown
    formik.setFieldValue('user', keyword);

    if (e.key == "Backspace" || e.key === "Delete") {
      setSelectedUser(null);
    }


    if (keyword.length > 0) {
      setLoading(true); // Set loading state
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL
          }/members/searchuser?name=${encodeURIComponent(keyword)}`
        );
        console.log(response, 'lllllllffffffff');
        const allUsers = response.data; // Get all users from API
        // Filter users whose names start with the keyword (case insensitive)
        const filteredUsers = allUsers.filter(user =>
          user.name.toLowerCase().startsWith(keyword.toLowerCase())
        );


        setUsers(filteredUsers); // Store users from API
        setShowDropdown(true); // Show dropdown
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false); // Stop loading
      }
    }
    else {
      setShowDropdown(false); // Hide dropdown when input is cleared
      setUsers([]); // Clear users
    }
  };
  // const handleSelectUser = (user) => {
  //   setSelectedUser(user.name);
  //   formik.setFieldValue('user', user._id); // Set the selected user in the input
  //   setShowDropdown(false); // Hide dropdown after selecting a user
  // };

  const formik = useFormik({
    initialValues: {
      name: '',
      DOB: '',
      qualification: '',
      description: '',
      aboutMe: '',
      user: '',
      status: '',

      image: '',
    },
    validationSchema: Yup.object({
      name: Yup.string().required('Please enter a name'),
      DOB: Yup.date().required('Please select a date of birth'),
      qualification: Yup.string().required('Please enter a qualification'),
      description: Yup.string().required('Please enter a qualification'),
      aboutMe: Yup.string().required('Please provide details about yourself'),
      user: Yup.string().required('Please select a User'),
      status: Yup.string().required('Please select a Status'),

    }),
    onSubmit: async (values) => {



      const data = {
        ...values,
        user: values.user,
        status: values.status,

        image: img,
      };
      console.log(data, "dddddddppppppp");


      try {
        await axios.put(`${process.env.REACT_APP_API_BASE_URL}/matrimonial/updateMatrimonial/${id}`, data, {
          headers: {
            'Content-Type': 'application/json',
          },
        });
        toast.success('Matrimonial updated successfully!', {
          position: 'bottom-right',
        });
        navigate('/matrimonial/list');
      } catch (error) {
        console.log(error, "helloerrrrrrrrrrrrr");

        toast.error(error?.response?.data?.error || 'An error occurred', {
          position: 'bottom-right',
        });
      }
    },
    enableReinitialize: true,
  });
  const handleSelectUser = (user) => {
    // Save the user's ID to the form values instead of the full user object
    formik.setFieldValue('user', user._id); // Store the user's ID in form values
    setSelectedUser(user.name); // Display the selected user's name in the input field
    setShowDropdown(false); // Close the dropdown
  };


  if (!initialValuesLoaded) {
    return <div>Loading...</div>;
  }

  return (
    <Container maxWidth="lg">
      <Card>
        <form onSubmit={formik.handleSubmit} style={{ margin: 30 }}>
          <Grid item xs={12}>
            <Card>
              <CardHeader
                title="Edit Matrimonial"
                titleTypographyProps={{
                  style: {
                    margin: 0,
                    width: '100%',
                    color: '#000',
                    fontWeight: 700,
                    fontSize: '25px',
                    marginBottom: '30px'
                  }
                }}
              />

              <CardContent>
                <Box component="form" noValidate autoComplete="off">

                  <div
                    style={{
                      display: 'flex',
                      // justifyContent: 'space-between',
                      flexWrap: 'wrap'
                    }}
                  >

                    <div style={{ margin: 9, width: '48%' }}>
                      <TextField
                        fullWidth
                        label="Name"
                        name="name"
                        value={formik.values.name}
                        onChange={(e) => {
                          const { value } = e.target;
                          const formattedValue = value.charAt(0).toUpperCase() + value.slice(1);
                          formik.setFieldValue('name', formattedValue);

                        }}
                        onBlur={formik.handleBlur}
                        error={formik.touched.name && Boolean(formik.errors.name)}
                        helperText={formik.touched.name && formik.errors.name}
                      />
                    </div>
                    <div style={{ margin: 9, width: '48%' }}>
                      <TextField
                        fullWidth
                        type="date"
                        label="Date of Birth"
                        name="DOB"
                        value={formik.values.DOB}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.DOB && Boolean(formik.errors.DOB)}
                        helperText={formik.touched.DOB && formik.errors.DOB}
                        InputLabelProps={{ shrink: true }} // Keeps the label above the input
                      />
                    </div>

                  </div>
                  <div
                    style={{
                      display: 'flex',
                      // justifyContent: 'space-between',
                      flexWrap: 'wrap'
                    }}
                  >
                    <div style={{ margin: 9, width: '48%' }}>
                      <TextField
                        fullWidth
                        label="Qualification"
                        name="qualification"
                        value={formik.values.qualification}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.qualification && Boolean(formik.errors.qualification)}
                        helperText={formik.touched.qualification && formik.errors.qualification}
                      />
                    </div>
                    <div style={{ margin: 9, width: '48%', position: 'relative' }}>
                      <TextField
                        fullWidth
                        label="User"
                        name="user"
                        value={selectedUser}
                        onKeyDown={(e) => handleupdate(e)} // Use modified handleupdate
                        onBlur={formik.handleBlur}
                        onChange={(e) => handleupdate(e)}
                        error={formik.touched.user && Boolean(formik.errors.user)}
                        helperText={formik.touched.user && formik.errors.user}
                        autoComplete="off"
                        disabled
                        required
                      />

                      {/* Loading indicator */}
                      {loading && (
                        <CircularProgress
                          size={24}
                          style={{ position: 'absolute', right: 10, top: 35 }}
                        />
                      )}

                      {/* Dropdown list */}
                      {showDropdown && users.length > 0 && (
                        <List
                          ref={inputRef}
                          style={{
                            border: '1px solid #ccc',
                            maxHeight: 200,
                            overflowY: 'auto',
                            position: 'absolute',
                            width: '100%',
                            backgroundColor: '#fff',
                            zIndex: 1000
                          }}
                        >
                          {users.map((user) => (
                            <ListItem
                              button
                              key={user._id}
                              onClick={() => handleSelectUser(user)}
                            >
                              <ListItemText primary={user.name} />
                            </ListItem>
                          ))}
                        </List>
                      )}
                    </div>
                  </div>

                  <div style={{ margin: 9, width: '97%' }}>
                    <ReactQuill
                      value={formik.values.aboutMe}
                      onChange={(content, delta, source, editor) => {
                        formik.setFieldValue('aboutMe', content); // Update Formik state
                      }}
                      onBlur={() => formik.setFieldTouched('aboutMe', true)} // Mark as touched
                      modules={{
                        toolbar: [
                          [{ header: [1, 2, false] }],
                          ['bold', 'italic', 'underline'],
                          ['link', 'image'],
                          [{ color: [] }], // Add color dropdown

                          ['clean'] // remove formatting button
                        ]
                      }}
                      formats={[
                        'header',
                        'bold',
                        'italic',
                        'underline',
                        'link',
                        'color'
                      ]}
                    />
                    {formik.touched.aboutMe && formik.errors.aboutMe && (
                      <div style={{ color: 'red', marginTop: '5px' }}>
                        {formik.errors.aboutMe}
                      </div>
                    )}
                   
                    <TextField
                      fullWidth
                      type="text"
                      label="Push Notification Description"
                      name="description"
                      multiline={true} // Enables multiline input
                      rows={4} // Adjusts the height of the text area
                      value={formik.values.description}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={formik.touched.description && Boolean(formik.errors.description)}
                      helperText={formik.touched.description && formik.errors.description}
                      style={{ marginTop: "5px" }}
                    />

                  </div>
                  <div style={{ margin: 9, width: '48%' }}>
                    <Select
                      fullWidth
                      label="Status"
                      name="status"
                      value={formik.values.status}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}

                      error={formik.touched.status && Boolean(formik.errors.status)}
                    >
                      <MenuItem value="">
                        <em>Select Status</em>
                      </MenuItem>
                      <MenuItem value="true">True</MenuItem>
                      <MenuItem value="false">False</MenuItem>
                    </Select>
                    {formik.touched.status && formik.errors.status && (
                      <div style={{ color: 'red', fontSize: 12, marginTop: 5 }}>
                        {formik.errors.status}
                      </div>
                    )}
                  </div>

                  <div style={{ margin: 9, width: '32%' }}>

                    <input type="file" onChange={handleImageFile} />
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      {/* <AttachFileIcon />
                          <label>Choose an Image</label> */}
                    </div>
                    {img && <img src={img} alt="Uploaded" style={{ maxWidth: '170px' }} />}
                  </div>





                </Box>
              </CardContent>
              <div
                style={{
                  display: 'flex',
                  // justifyContent: 'flex-end',
                  margin: '20px',
                }}
              >

                <Button variant="contained" color="primary" type="submit">
                  Submit
                </Button>
              </div>


            </Card>
          </Grid>
        </form>
      </Card>
    </Container>
  );
};

export default EditMatrimonial;

